class ProductFaq extends HTMLElement {
  connectedCallback() {
    this.unsubscribe?.();
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const root = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
      if (root?.dataset.section !== event.data?.sectionId) return;
      this.sync(event.data?.variant?.id);
    });
    this.addEventListener('click', this.onClick = () => {
      const root = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
      this.sync(root?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value);
    }, {capture: true});
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    this.removeEventListener('click', this.onClick, {capture: true});
  }
  sync(variantId) {
    if (!variantId) return;
    for (const link of this.querySelectorAll('[data-bundle-cta][data-preselect-param]')) {
      const url = new URL(link.href, location.origin);
      const param = link.dataset.preselectParam;
      const current = url.searchParams.get(param) || '';
      const prefix = current.includes(':') ? current.slice(0, current.lastIndexOf(':') + 1) : '';
      url.searchParams.set(param, prefix + String(variantId));
      link.href = url.pathname + url.search;
    }
  }
}
if (!customElements.get('product-faq')) customElements.define('product-faq', ProductFaq);
